import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileFinderHome.html?raw';
import "../FileFinder/FileFinderTypes";
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
class FileFinderHome extends compose(FinderViewBase) {
    templateString: any = template;

    resultActionbar: HTMLElement;
    buttonClickTimeout: number = null;

    // damit man das name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    filesTableParams: tableParams = { widgetName: "filesTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "FileFinder/GetFileList";
    loadFinderConfigUrl = "FileFinder/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["FileFinder_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["FileFinder_BtnSubmit"];

    filesTable_formatterFunction(cell: StaticTable.StaticTableCell<FileFinder.FileDescriptor>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        if (entity.color) {
            node.parentElement.style.backgroundColor = entity.color.backgroundHex;
        }

        switch (colName) {
            case "Action":
                var btn = new Button();
                btn.setLabel("Download");

                if (entity.isFileFound === false) {
                    btn.setReadonly(true);
                }

                btn.setClasses("mds-hover-bright pL1", "w3-disabled tertiaryBG");
                btn.setIconLeft("fas fa-download");

                btn._onClick_Button = lang.hitch(this, this._onClick_Download, entity);
                btn.placeAt(node);
                return true;
                break;
            default:
                return false;
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        this.getFilterlist();
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.filesTableParams) {

            // z.B. gleich eine Tabelle kreieren
            this.createTable(this.filesTableParams.widgetName, this[this.filesTableParams.sContainerNodeName], "default", this._completeList, lang.hitch( this, this.filesTable_formatterFunction ));
        } 
    }
    // --------------overrides ------------------------------------end
    // --------------------own methods ----------------------------start
    _onClick_Download(entity: FileFinder.FileDescriptor) {
        //console.log("_onClick_Download", entity);
        let url = window.appRoot + "FileFinder/Download?downloadKey=" + entity.downloadKey;
        window.open(url);
    }
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileFinderHome);